import { IonIcon, IonItem } from "@ionic/react";
import React from "react";
import { formatDate } from "../../common/commonFunctions";
import { callSharp, chevronForward } from "ionicons/icons";

const DetailsCard: React.FC<{
  status: string;
  color?:
    | "tertiary"
    | "orange"
    | "brown"
    | "purple"
    | "secondary"
    | "success"
    | "navblue"
    | "medium"
    | "dark"
    | "danger"
    | "primary";
  name: { label: string; value: string; phone?: string };
  id: number;
  createdOn: string;
  callWhatsapp?: (phone: string) => void;
  muteBg?: boolean;
  onClick?: () => void;
}> = (props) => {
  const getStatusColor = (): string => {
    return props?.color
      ? `var(--ion-color-${props.color})`
      : `var(--ion-color-success)`;
  };

  return (
    <IonItem color={props.muteBg ? "light" : undefined}>
      <div
        style={{
          width: "100%",
          paddingTop: "10px",
          paddingBottom: "10px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
        onClick={props?.onClick}
      >
        <div
          style={{
            flexGrow: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              paddingTop: "10px",
              paddingBottom: "5px",
              fontSize: "small",
            }}
          >
            <div
              style={{
                fontWeight: "bold",
                fontSize: "medium",
                color: props?.muteBg
                  ? "var(--ion-color-medium)"
                  : "var(--ion-color-dark)",
              }}
            >
              ID: {props.id}
            </div>
            <div
              style={{
                fontWeight: "bold",
                background: getStatusColor(),
                color: "white",
                padding: "5px",
                borderRadius: "3px",
              }}
            >
              {props.status}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div
              style={{
                fontSize: "small",
                paddingTop: "5px",
                paddingBottom: "10px",
                color: props?.muteBg
                  ? "var(--ion-color-medium)"
                  : "var(--ion-color-dark)",
              }}
              onClick={(e) => {
                e.stopPropagation();
                if (props.name.phone) {
                  props?.callWhatsapp(props.name.phone);
                }
              }}
            >
              <div
                style={{
                  fontSize: "x-small",
                  marginBottom: "5px",
                  color: "var(--ion-color-medium)",
                }}
              >
                {props?.name.label}
              </div>
              <div style={{ display: "flex", alignItems: "center" }}>
                {props.name?.phone && (
                  <div style={{ paddingRight: "5px" }}>
                    <IonIcon icon={callSharp} />
                  </div>
                )}
                <div>{props.name.value}</div>
              </div>
            </div>
            <div
              style={{
                fontSize: "small",
                paddingTop: "5px",
                paddingBottom: "10px",
                textAlign: "right",
              }}
            >
              <div
                style={{
                  fontSize: "x-small",
                  marginBottom: "5px",
                  color: "var(--ion-color-medium)",
                }}
              >
                Date
              </div>
              <div
                style={{
                  color: props?.muteBg
                    ? "var(--ion-color-medium)"
                    : "var(--ion-color-dark)",
                }}
              >
                {formatDate(props.createdOn)}
              </div>
            </div>
          </div>
          {props.children}
        </div>
        {/* {!!props?.onClick && (
          <div style={{ flexShrink: 0, paddingLeft: "10px" }}>
            <IonIcon icon={chevronForward} color="medium" />
          </div>
        )} */}
      </div>
    </IonItem>
  );
};

export default DetailsCard;
